import React from 'react';

export default function SearchBar({ value, onChange, onSearch, placeholder }) {

  const handleSubmit = e => {
    e.preventDefault();
    onSearch();
  };

  return (
    <form onSubmit={handleSubmit} className="d-flex mb-3">

      <input
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        className="form-control form-control-lg"
        style={{
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0
        }}
      />

      <button
        type="submit"
        className="btn btn-primary btn-lg"
        style={{
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          minWidth: "140px",
          fontWeight: "600"
        }}
      >
        بحث / Search
      </button>

    </form>
  );
}
